import { IActivityScheduleSessionBlockBase } from '../../models/activities';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUnblockActivityScheduleSessionBlocksServiceProps {
  activityId: string;
  blockId: string;
}

type Response = IActivityScheduleSessionBlockBase;

export async function unblockActivityScheduleSessionBlocksService({
  activityId,
  blockId,
}: IUnblockActivityScheduleSessionBlocksServiceProps): Promise<Response> {
  const { data } = await jhsfBookingsApi.post(
    `/activities/${activityId}/session-blocks/${blockId}/unblock`,
    {},
  );

  return data;
}
